var _path, _g, _path2, _path3, _g2, _path4, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnboardingSuccess = function SvgOnboardingSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 228,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 125c26.234 0 47.5-21.266 47.5-47.5 0-26.233-21.266-47.5-47.5-47.5S127 51.267 127 77.5c0 26.234 21.266 47.5 47.5 47.5Z",
    fill: "#2D2F7A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#onboarding-success_svg__a)",
    fill: "#81E6D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.135 86.635c-2.1 0-3.9-1.8-3.9-4.05s1.8-3.9 3.9-3.9c2.1 0 3.9 1.8 3.9 3.9 0 2.1-1.65 4.05-3.9 4.05Zm0-4.95c-.45 0-.9.45-.9.9s.45.9.9.9c.6.15 1.05-.3 1.05-.9 0-.6-.45-.9-1.05-.9ZM161.135 97.135c-2.1 0-3.9-1.8-3.9-4.05s1.8-3.9 3.9-3.9c2.1 0 3.9 1.8 3.9 3.9 0 2.1-1.65 4.05-3.9 4.05Zm0-4.95c-.45 0-.9.45-.9.9s.45.9.9.9c.6.15 1.05-.3 1.05-.9 0-.6-.45-.9-1.05-.9ZM185.154 89.322c-4.455 0-10.288-2.864-15.273-7.849-3.394-3.394-5.94-7.425-7.107-11.137-1.272-4.03-.848-7.425 1.273-9.546 4.137-4.136 13.258-1.59 20.683 5.834 3.394 3.394 5.94 7.424 7.106 11.137 1.273 4.03.849 7.424-1.272 9.546-1.379 1.379-3.288 2.015-5.41 2.015Zm-15.698-27.577c-1.485 0-2.545.424-3.288 1.166-1.272 1.273-1.485 3.607-.636 6.576.955 3.289 3.394 6.789 6.47 9.865 6.682 6.682 13.895 8.379 16.44 5.833 1.273-1.273 1.485-3.606.637-6.576-.955-3.288-3.394-6.788-6.47-9.864-4.667-4.667-9.758-7-13.153-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.319 101.519c-.636 0-1.167-.318-1.379-.954-.318-.743.106-1.591.849-1.91l36.486-12.94c.743-.318 1.591.107 1.909.85.319.742-.106 1.59-.848 1.908l-36.487 12.94c-.212.213-.424.212-.53.106Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.319 101.519h-.424c-.849-.212-1.273-1.06-1.061-1.909l8.167-27.259c.213-.848 1.061-1.272 1.91-1.06.848.212 1.272 1.06 1.06 1.909l-8.167 27.259c-.318.742-.848 1.06-1.485 1.06ZM194.17 56.76l2.546-.849 2.545.849-.848-2.546.848-2.546-2.545.849-2.546-.849.849 2.546-.849 2.546ZM196.291 71.609l2.546-.849 2.545.849-.848-2.546.848-2.545-2.545.848-2.546-.848.849 2.545-.849 2.546ZM177.306 55.169l4.348-1.38 4.349 1.38-1.379-4.35 1.379-4.348-4.349 1.379-4.348-1.379 1.378 4.349-1.378 4.349Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M100.019 87.01a11.01 11.01 0 1 1-22.02-.002 11.01 11.01 0 0 1 22.02.001ZM49 61.625a6.626 6.626 0 1 1 13.251 0 6.626 6.626 0 0 1-13.251 0Z",
    fill: "#EAEAF7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "onboarding-success_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 285,
    y: 74,
    width: 16,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285 74h16v16h-16V74Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#onboarding-success_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.148 90h-8.296A3.857 3.857 0 0 1 285 86.148v-8.296A3.855 3.855 0 0 1 288.852 74h8.296A3.857 3.857 0 0 1 301 77.852v8.296A3.855 3.855 0 0 1 297.148 90Zm-8.296-13.032a.89.89 0 0 0-.889.889v8.291a.891.891 0 0 0 .889.89h8.296a.888.888 0 0 0 .884-.89v-8.296a.888.888 0 0 0-.889-.89l-8.291.006Z",
    fill: "#EAEAF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "onboarding-success_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 51,
    width: 25,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271 76h-25V51h25v25Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#onboarding-success_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.018 51h12.964A6.026 6.026 0 0 1 271 57.018v12.964A6.026 6.026 0 0 1 264.982 76H252.02a6.024 6.024 0 0 1-6.018-6.018V57.02a6.022 6.022 0 0 1 6.018-6.018m12.962 20.37a1.388 1.388 0 0 0 1.389-1.39V57.02a1.387 1.387 0 0 0-1.389-1.39H252.02a1.387 1.387 0 0 0-1.389 1.39v12.962a1.387 1.387 0 0 0 1.389 1.39h12.962Z",
    fill: "#EAEAF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "onboarding-success_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(145 44)",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgOnboardingSuccess;